import { render, staticRenderFns } from "./SchoolData.vue?vue&type=template&id=588fe1e6&scoped=true&"
import script from "./SchoolData.vue?vue&type=script&lang=js&"
export * from "./SchoolData.vue?vue&type=script&lang=js&"
import style0 from "./SchoolData.vue?vue&type=style&index=0&id=588fe1e6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588fe1e6",
  null
  
)

export default component.exports